<template>
    <div class="content">
      <div class="card">
        <div class="card-header">
          Просмотр Файла - <strong>{{excel.original_filename}}</strong>
        </div>
        <div class="table-responsive">
          <table class="table table-hover table-bordered bg-white table-striped">
              <thead>
                  <th>Названия файла</th>
                  <th>Автор</th>
                  <th class="text-center">Статус</th>
                  <th>Тип</th>
                  <th>Кол-во данных</th>
                  <th>Дата загрузки</th>
                  <th class="text-center">Скачать</th>
              </thead>
              <tbody>
                <tr v-if="!loadExcels">
                  <td>{{excel.original_filename}}</td>
                  <td>{{excel.user ? excel.user.fullname: '' }}</td>
                  <td class="text-center">
                    <i class="fa fa-check text-success fa-lg" aria-hidden="true" v-if="excel.status == 'done'"></i>
                    <i class="fa fa-times text-danger fa-lg" aria-hidden="true" v-if="excel.status == 'failed'"></i>
                  </td>
                  <td>{{excel.type}}</td>
                  <td>{{excel.count}}</td>
                  <td>{{excel.created_at}}</td>
                  <td class="text-center">
                    <a :href="`${storagePath()}/${excel.path}`" class="btn btn-success">
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="loadExcels">
                  <td colspan="7" class="text-center">
                    <loader-wave/>
                  </td>
                </tr>
              </tbody>
          </table>
        </div>
      </div>
      <div class="mt-4 mb-1">
        <strong>Значение цветов</strong><br>
        <span class="text-success"><i class="fa fa-stop" aria-hidden="true"></i> - Успешно завершено</span><br>
        <span class="text-danger"><i class="fa fa-stop" aria-hidden="true"></i> - Не удалось выполнить</span>
      </div>
      <div class="block block-rounded block-bordered">
          <div class="block-content">
            <div class="nav btn-group mb-2">
              <a
                v-if="excel.import_debtors && excel.import_debtors.length != 0"
                id="home-tab"
                href="#home"
                class="btn btn-secondary btn-sm"
                data-toggle="tab"
                role="tab"
                aria-controls="home"
                :aria-selected="excel.type == 'import_debtors'"
                :class="{'active': excel.type == 'import_debtors' || excel.type == 'add_additional_data' }"
              >
                Список должников для импорта
              </a>
              <a
                v-if="excel.import_debts && excel.import_debts.length != 0"
                id="updatedebts-tab"
                href="#updatedebts"
                class="btn btn-secondary btn-sm"
                data-toggle="tab"
                role="tab"
                aria-controls="updatedebts"
                :aria-selected="excel.type == 'update_debts'"
                :class="{'active': excel.type == 'update_debts' }"
              >
                Список договоров для импорта
              </a>
              <a
                v-if="excel.import_deleted_debts && excel.import_deleted_debts.length != 0"
                id="deleteddebt-tab"
                href="#deleteddebt"
                class="btn btn-secondary btn-sm"
                data-toggle="tab"
                role="tab"
                aria-controls="deleteddebt"
                :aria-selected="excel.type == 'delete_debts'"
                :class="{'active': excel.type == 'delete_debts' }"
              >
                Список договоров для архива
              </a>
              <a
                v-if="excel.import_distribution_debts && excel.import_distribution_debts.length != 0"
                id="distrubddebt-tab"
                href="#distrubddebt"
                class="btn btn-secondary btn-sm"
                data-toggle="tab"
                role="tab"
                aria-controls="distrubddebt"
                :aria-selected="excel.type == 'distribution_debts'"
                :class="{'active': excel.type == 'distribution_debts' }"
              >
                Список договоров для распределение
              </a>
              <a
                v-if="excel.import_payments && excel.import_payments.length != 0"
                id="payments-tab"
                href="#payments"
                class="btn btn-secondary btn-sm"
                data-toggle="tab"
                role="tab"
                aria-controls="payments"
                :aria-selected="excel.type == 'add_payments'"
                :class="{'active': excel.type == 'add_payments' }"
              >
                Плетежы
              </a>
            </div>
            <div class="tab-content">
              <div v-if="excel.import_debtors && excel.import_debtors.length != 0" class="tab-pane fade" :class="{'show active': excel.type == 'import_debtors' || excel.type == 'add_additional_data' }" id="home" role="tabpanel" aria-labelledby="home-tab">
                <import-debtors :excel="excel" :load="loadExcels"/>
              </div>
              <div v-if="excel.import_debts && excel.import_debts.length != 0" class="tab-pane fade" :class="{'show active': excel.type == 'update_debts' }" id="updatedebts" role="tabpanel" aria-labelledby="updatedebts-tab">
                <import-debts :excel="excel" :load="loadExcels"/>
              </div>
              <div v-if="excel.import_deleted_debts && excel.import_deleted_debts.length != 0" class="tab-pane fade" :class="{'show active': excel.type == 'delete_debts' }" id="deleteddebt" role="tabpanel" aria-labelledby="deleteddebt-tab">
                <import-deleted-debts :excel="excel" :load="loadExcels"/>
              </div>
              <div v-if="excel.import_distribution_debts && excel.import_distribution_debts.length != 0" class="tab-pane fade" :class="{'show active': excel.type == 'distribution_debts' }" id="distrubddebt" role="tabpanel" aria-labelledby="distrubddebt-tab">
                <import-distribution-debts :excel="excel" :load="loadExcels"/>
              </div>
              <div v-if="excel.import_payments && excel.import_payments.length != 0" class="tab-pane fade" :class="{'show active': excel.type == 'add_payments' }" id="payments" role="tabpanel" aria-labelledby="payments-tab">
                <import-payments :excel="excel" :load="loadExcels"/>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import ImportDebtors from '@/components/admin/import/debtors.vue'
import ImportDebts from '@/components/admin/import/debts.vue'
import ImportDeletedDebts from '@/components/admin/import/deleted_debts.vue'
import ImportDistributionDebts from '@/components/admin/import/distribution_debts.vue'
import ImportPayments from '@/components/admin/import/payments.vue'

export default {
  data() {
    return {
      excel: {
        import_debtors: [],
        import_debts: [],
        import_deleted_debts: [],
        import_distribution_debts: [],
        import_payments: [],
      },
      loadExcels: false,
    }
  },
  mounted() {
    this.fetchExcel()
  },
  methods: {
    fetchExcel() {
      this.loadExcels = true;
      window.axios.get(`http://imports.kfn.kz/api/admin/imports/excels/${this.$route.params.id}`)
        .then((res) => {
            this.excel = res.data.importExcel;
        })
        .finally(() => {
            this.loadExcels = false;
        });
    },
  },
  components: {
    ImportDebtors,
    ImportDebts,
    ImportDeletedDebts,
    ImportDistributionDebts,
    ImportPayments,
  },
}
</script>
